// Identité de l'éditeur et vendeur du site, commune aux six langues.
//
// Depuis le 23/09/2026, le site est exploité par Sébastien Schoonjans,
// entrepreneur indépendant, personne physique (BCE 1042.744.456). Jusqu'au
// 22/09/2026 inclus, le vendeur était Charlotte Ansiaux (BCE 1000.107.018) :
// elle reste le vendeur des commandes ENCAISSÉES jusque-là (heure de
// Belgique), et les CGV le disent. C'est la date d'encaissement qui compte,
// comme dans le backend (app/services/vendeur.ts, vendeurPour).
//
// La BCE ne connaît à Sébastien Schoonjans AUCUNE dénomination commerciale
// autre que son propre nom : « MirumGames » et « Joyful Reveal » sont des noms
// de site et de produit, jamais une raison sociale. Ne pas réintroduire de
// ligne « Nom commercial : MirumGames » dans les mentions légales.
//
// MIROIR du module vendeur du backend (backend-adonis/app/services/vendeur.ts),
// qui imprime les factures. Les deux paquets sont construits séparément et ne
// peuvent pas partager un fichier : le test backend
// tests/unit/services/vendeur.spec.ts vérifie que ce fichier dit la même chose.
// Toute modification se fait des DEUX côtés.
//
// Les coordonnées bancaires ne figurent QUE sur les factures, jamais ici.

export const VENDEUR = Object.freeze({
  nom: 'Sébastien Schoonjans',
  numeroEntreprise: '1042.744.456',
  numeroTva: 'BE 1042.744.456',
  email: 'hello@mirumgames.com',
  telephone: '+32 492 98 69 21',
  adresse: Object.freeze({
    rue: 'Rue de la Cortaille 59',
    localite: 'Freux',
    codePostal: '6800',
    commune: 'Libramont-Chevigny',
  }),
});

/** Le vendeur des commandes encaissées jusqu'au 22/09/2026 inclus. */
export const ANCIEN_VENDEUR = Object.freeze({
  nom: 'Charlotte Ansiaux',
  numeroEntreprise: '1000.107.018',
});

const LIEN = 'text-blue-600 hover:text-blue-800 underline';

/** « Rue de la Cortaille 59, Freux, 6800 Libramont-Chevigny, <pays> ». */
export function adresseVendeur(pays) {
  const a = VENDEUR.adresse;
  return `${a.rue}, ${a.localite}, ${a.codePostal} ${a.commune}, ${pays}`;
}

export const COURRIEL = `<a href="mailto:${VENDEUR.email}" class="${LIEN}">${VENDEUR.email}</a>`;

export const TELEPHONE = `<a href="tel:${VENDEUR.telephone.replace(/\s/g, '')}" class="${LIEN}">${VENDEUR.telephone}</a>`;

/**
 * Encadré « informations sur l'entreprise » des mentions légales, avec les
 * libellés de la langue de la page (`sep` : « : » en français, « : » ailleurs).
 */
export function encadreIdentite(l) {
  const s = l.sep;
  return (
    `<strong>${l.nom}${s}</strong> ${VENDEUR.nom}<br />` +
    `<strong>${l.statut}${s}</strong> ${l.statutValeur}<br />` +
    `<strong>${l.adresse}${s}</strong> ${adresseVendeur(l.pays)}<br /><br />` +
    `<strong>${l.bce}${s}</strong> ${VENDEUR.numeroEntreprise}<br />` +
    `<strong>${l.tva}${s}</strong> ${VENDEUR.numeroTva}<br /><br />` +
    `<strong>${l.email}${s}</strong> ${COURRIEL}<br />` +
    `<strong>${l.telephone}${s}</strong> ${TELEPHONE}`
  );
}
